import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import { ReactNode, type JSX } from "react";
import UserRecipientListItem from "./UserRecipientListItem";
import { UserRecipientFieldArrayType } from "./UserRecipientFieldTypes";

export type UserRecipientListProps = {
    title: string;
    icon: JSX.Element | ReactNode;
    recipients: UserRecipientFieldArrayType;
    onEdit?: (recipientKey: string) => void;
    onDisable?: (recipientKey: string, disable: boolean) => void;
    onDelete?: (recipientKey: string) => void;
    hideUsage?: boolean;
    flat?: boolean;
};

export default function UserRecipientList({
    title,
    icon,
    recipients,
    onEdit,
    onDisable,
    onDelete,
    hideUsage,
    flat
}: UserRecipientListProps) {

    return (
        <Card
            raised={!flat}
            sx={{
                flex: "0 0 auto",
                backgroundColor: flat ? "custom.background.cardContainer" : undefined,

            }}
        >
            <CardHeader
                sx={{
                    padding: 1
                }}
                title={title}
                avatar={icon}
                slotProps={{
                    title: { 
                        sx: {
                            fontWeight: "bold"
                        }
                    }
                }}
            />
            <CardContent
                sx={{
                    padding: 1,
                    paddingBottom: theme => `${theme.spacing(1)} !important`
                }}
            >
                <Stack direction="column" spacing={1}>
                    {recipients.map(recipient =>
                        <UserRecipientListItem
                            key={recipient.fieldID}
                            recipient={recipient}
                            onEdit={onEdit}
                            onDisable={onDisable}
                            onDelete={onDelete}
                            hideUsage={hideUsage}
                        />
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
}